import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../components/Header";
import PrivateRoute from "./PrivateRoute";
import routes from "./route";
import { RootState } from "../redux/store";

const HomePage = lazy(() => import("../pages/home"));
const LoginPage = lazy(() => import("../pages/login"));
const ResetPassword = lazy(() => import("../pages/reset-password"));
const Contact = lazy(() => import("../pages/contact"));

const LoadingStyles: React.CSSProperties = {
  position: "absolute",
  right: "5%",
  bottom: "5%",
};

const Loading = <div style={LoadingStyles}>loading...</div>;

const RoutesComponent = () => {
  const { isLoggedIn } = useSelector(({ user }: RootState) => user);
  return (
    <Suspense fallback={Loading}>
      {isLoggedIn && <Header />}
      <Switch>
        <Route path="/reset-password">
          <ResetPassword />
        </Route>
        <Route path="/login">
          <LoginPage />
        </Route>
        <PrivateRoute exact path="/">
          <HomePage />
        </PrivateRoute>
        <PrivateRoute path="/contact">
          <Contact />
        </PrivateRoute>
        {routes.map(
          ({
            key,
            private: isPrivate = false,
            component: Component,
            path,
            children,
            ...route
          }) => {
            if (isPrivate) {
              if (children && children.length > 0) {
                const mapped = children.map(
                  ({
                    key: childKey,
                    component: ChildComponent,
                    path: childPath,
                    ...child
                  }) => (
                    <PrivateRoute
                      key={childKey}
                      path={path + childPath}
                      {...child}
                    >
                      <ChildComponent />
                    </PrivateRoute>
                  )
                );
                mapped.push(
                  <PrivateRoute key={key} path={path} {...route}>
                    <Component />
                  </PrivateRoute>
                );
                return mapped;
              }
              return (
                <PrivateRoute key={key} path={path} {...route}>
                  <Component />
                </PrivateRoute>
              );
            }
            if (children && children.length > 0) {
              const mapped = children.map(
                ({
                  key: childKey,
                  component: ChildComponent,
                  path: childPath,
                  ...child
                }) => (
                  <Route key={childKey} path={path + childPath} {...child}>
                  <ChildComponent />
                  </Route>
                )
              );
              mapped.push(
                <Route key={key} path={path} {...route}>
                  <Component />
                </Route>
              );
              return mapped;
            }
            return (
              <Route key={key} path={path} {...route}>
                <Component />
              </Route>
            );
          }
        )}
      </Switch>
    </Suspense>
  );
};

export default RoutesComponent;
